export const ONESTEP_VCD = 'ONE-STEP-VCD'